// Platform detection for Telegram WebApp vs Standalone browser

export const Platform = {
  TELEGRAM: 'telegram',
  STANDALONE: 'standalone'
};

/**
 * Detects whether the app is running inside Telegram WebApp or as standalone
 * @returns {string} Platform.TELEGRAM or Platform.STANDALONE
 */
export function detectPlatform() {
  // Check if Telegram WebApp SDK is available and initialized with data
  if (
    typeof window !== 'undefined' &&
    window.Telegram?.WebApp?.initData &&
    window.Telegram.WebApp.initData !== ''
  ) {
    return Platform.TELEGRAM;
  }
  return Platform.STANDALONE;
}

// Cached platform detection (runs once on module load)
export const currentPlatform = detectPlatform();

// Convenience boolean flags
export const isTelegram = currentPlatform === Platform.TELEGRAM;
export const isStandalone = currentPlatform === Platform.STANDALONE;

// Debug helper - can be called from console: window.__footyPlatform()
if (typeof window !== 'undefined') {
  window.__footyPlatform = () => ({
    platform: currentPlatform,
    isTelegram,
    isStandalone,
    telegramInitData: window.Telegram?.WebApp?.initData ? 'present' : 'missing'
  });
}
